module.exports = __webpack_public_path__ + "media/images/pc/page_common/purpose_photographer-bc075dbcb6e47ae9daf18c3b01f7e8a5.png";